import { render, staticRenderFns } from "./JobOrderShowDetail.vue?vue&type=template&id=77f40fb6&"
import script from "./JobOrderShowDetail.vue?vue&type=script&lang=js&"
export * from "./JobOrderShowDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports